import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {Http, Response} from '@angular/http';
import {ISSUANCE_INVESTOR} from '../../models/issuance';
import {VW_SERIES_SA} from '../../models/seriessa';
import { SERIES } from '../../models/series';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {HeaderService} from '../../header.service';
import {ProfileService} from '../../profile.service';
import {ActivatedRoute, Router, RoutesRecognized} from '@angular/router';
import * as Globals from '../../globals';

const url = Globals.serviceUrl;

@Component({
  selector: 'app-penjatahanissuance',
  templateUrl: './penjatahanissuance.component.html',
  styleUrls: ['./penjatahanissuance.component.css']
})
export class PenjatahanIssuanceComponent implements OnInit {

  idtyNo: string;
  invId: number;
  issuances: ISSUANCE_INVESTOR[];
  dataIssuances: ISSUANCE_INVESTOR[];
  tab: number = 1;
  param: any;
  search: string = '';
  priority: string = '';
  paId: number = 0;
  loading: boolean;
  seriesId: number;
  totBids: number = 0;
  totAlts: number = 0;
  altP: number;
  bidNP: number = 0;
  paramSeries: any = {OPEN: false};
  urlFile = Globals.archiveUrl + 'bids?code=';
  series: SERIES[];
  seri: SERIES;
  p: number = 1;
  userProfile: any;
  authMenu: any;
  colSort: string[] = ['BID_DATE'];
  reverse: boolean = true;
  col: number = 5;
  rptType: number = 1;
  checkItems: number = 0;
  checked: boolean;
  cds: any[];
  seriessa: VW_SERIES_SA[];
  totRedeem: number = 0;
  allotNPTarget: number = 0;
  minBid: number = 0;
  incrBid: number = 0;
  targetGap: number = 0;
  targetSeries: number = 0;
  isLock: boolean = false;
  lockInput:boolean = false;

  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = {M_FLAG: null};
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/penjatahan/issuance/0') {
          this.tab = 1;
          this.router.navigate(['/penjatahan/issuance/1']);
        }
      }
      ;
    });
  }

  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/penjatahan/issuance/1']);
    }
    this.issuances = [];
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getSeries();
      this.authMenu = Globals.getAuthMenu(202, this.userProfile);
    }
  }

  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['INV_ID'];
        break;
      case 2:
        this.colSort = ['INV_NAME'];
        break;
      case 3:
        this.colSort = ['BID_ID'];
        break;
      case 4:
        this.colSort = ['ALT_AMT'];
        break;
      case 5:
        this.colSort = ['BID_DATE'];
        break;
      case 6:
        this.colSort = ['BID_AMT'];
        break;
      case 7:
        this.colSort = ['SELLING_AGENT'];
        break;
      case 8:
        this.colSort = ['STAT_ISSUE'];
        break;
      default:
        break;
    }
  }

  seriesChanged(ev: any) {
    this.seriesId = ev.target.value;
    this.getSeri(this.seriesId);
    // for (var i = 0; i < this.series.length; i++) {
    //   if (this.seriesId === this.series[i].SERIES_ID) {
    //     this.paramSeries = this.series[i];
    //     alert(this.paramSeries.TARGET);
    //     this.incrBid = this.paramSeries.INCREMENTAL;
    //     if (this.paramSeries.LOCK_YN === 1) {
    //       this.isLock = true;
    //       this.lockInput = this.isLock;
    //     }
    //     // console.log(this.paramSeries);
    //     break;
    //   }
    // }
  }

  getSeri(id: number) {
    this.seriesId = id;
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/series?id=' + this.seriesId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.seri = res.json();
        this.paramSeries = this.seri;
        this.getIssues();
        this.getAltP();
        this.getBidNP();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  priorityChanged(ev: any) {
    if (ev == 0) {
      this.priority = null;
    }
    else {
      this.priority = ev.target.value;
    }
    this.getIssues();
  }

  paIdChanged(ev: any) {
    this.paId = ev.target.value;
    this.getIssues();
  }

  getAltP() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/allotpbyseries?seriesId=' + this.seriesId, {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
          // console.log(res.json());
          this.altP = res.json();
          this.loading = false;
          this.targetGap = this.paramSeries.TARGET - this.altP;
        },
        err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
  }

  getBidNP() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/bidnpbyseries?seriesId=' + this.seriesId, {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
          // console.log(res.json());
          this.bidNP = res.json();
          this.loading = false;
        },
        err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
  }

  getIssues() {
    this.loading = true;
    this.http.get(url + 'ritel/penjatahanissuances?seriesId=' + this.seriesId + '&search=' + this.search + '&priority=' + this.priority + '&paId=' + this.paId + '&t=' + new Date().getTime(), {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
        this.issuances = res.json();
        this.totBids = 0;
        this.totAlts = 0;
        for (var i = 0; i < this.issuances.length; i++) {
          this.totBids += this.issuances[i].BID_AMT;
          this.totAlts += this.issuances[i].ALT_AMT;
        }
        /*if (!this.paramSeries.OPEN) {
          this.toastr.warning('Masa penawaran telah berakhir');
        }*/
        this.getCds(33);
        this.getSeriesSa();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getSeries() {
    this.loading = true;
    this.http.get(url + 'ritel/issueactive?cdOnline=1&t=' + new Date().getTime(), {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.seriesId = this.series[0].SERIES_ID;
          for (var i = 0; i < this.series.length; i++) {
            if (this.seriesId === this.series[i].SERIES_ID) {
              this.paramSeries = this.series[i];
              this.incrBid = this.paramSeries.INCREMENTAL;
              //alert(this.series[i].TARGET);
              if (this.paramSeries.LOCK_YN === 1) {
                this.isLock = true;
                this.lockInput = this.isLock;
              }
              // console.log(this.paramSeries);
              break;
            }
          }
          this.getIssues();
          this.getAltP();
          this.getBidNP();
          /*
          if (this.targetGap > this.bidNP) {
            this.allotNPTarget = this.bidNP;
          }
          */
          ;
          this.loading = false;
        } else if (this.series.length === 0) {
          //this.toastr.warning('Masa penawaran telah berakhir');
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getSeriesSa() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/seriessa?seriesId=' + this.seriesId + '&t=' + new Date().getTime(), {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
        this.seriessa = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getCds(cgNo: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=' + cgNo + '&t' + new Date().getTime(), {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
        this.cds = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  generateReport(format: string) {

    this.param = {
      TICKET_ID: 0,
      TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",rpttype:' + this.rptType + '}'
    };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'Rpt901?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  downloadCSV() {
    this.param = {TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '"}'};
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'ExportCSVI?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  allotment() { 
    if (this.allotNPTarget % this.incrBid !== 0) {
      this.toastr.error('Target Penjatahan harus sesuai kelipatan');
    }   
    else if (this.allotNPTarget > this.bidNP) {
      this.toastr.error('Target Penjatahan melebihi pemesanan buffer');
    }    
    else {
      this.loading = true;
      this.http.get(Globals.serviceUrl + 'ritel/seriesallot?seriesId=' + this.seriesId + '&allotmentTarget=' + this.allotNPTarget, {headers: this.headerService.getHeader()})
        .subscribe((res: Response) => {
          //     this.param = res.json();
          //     var reportUrl = Globals.reportUrl;
          //     window.open(reportUrl + 'Rpt901?id=' + this.param.TICKET_ID, '_blank');

          this.getSeri(this.seriesId);
          //this.allotNPTarget = null;
          this.loading = false;
          this.toastr.success('Penjatahan Buffer Berhasil');
        }, err => {
          this.loading = false;
          this.toastr.error(Globals.errorMessage(err));
          console.log(err);
        });
    }
  }

  allotNPReset() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/allotreset?seriesId=' + this.seriesId, {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
        //     this.param = res.json();
        //     var reportUrl = Globals.reportUrl;
        //     window.open(reportUrl + 'Rpt901?id=' + this.param.TICKET_ID, '_blank');
        this.getSeri(this.seriesId);
        this.loading = false;
        this.toastr.success('Penjatahan Buffer Telah Direset');
      }, err => {
        this.loading = false;
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  locking() {
    /*console.log(this.isLock);
    this.isLock = !this.isLock;
    console.log(this.isLock);*/
    // console.log(this.isLock);

    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/lock?seriesId=' + this.seriesId + '&locking=' + this.lockInput, {headers: this.headerService.getHeader()})
      .subscribe((res: Response) => {
        //     this.param = res.json();
        //     var reportUrl = Globals.reportUrl;
        //     window.open(reportUrl + 'Rpt901?id=' + this.param.TICKET_ID, '_blank');
        this.getSeri(this.seriesId);
        this.isLock = this.lockInput;
        this.loading = false;
        this.toastr.success('Konfirmasi penjatahan berhasil');
      }, err => {
        this.loading = false;
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/penjatahan/issuance/penjatahanissuance.component.ts